// extracted by mini-css-extract-plugin
export default {"root":"DashboardPage_root__6dWZT","container":"DashboardPage_container__OUjPu"};